import React from 'react'

export default function colorText(
  key: string,
  text: string,
  style?: React.CSSProperties,
) {
  const regex = new RegExp(key.toLowerCase())
  const start = text.toLowerCase().match(regex)?.index || 0
  const l = text.toLowerCase().match(regex)?.[0]?.length || 0
  const end = start + l

  return (
    <>
      <span>{text.slice(0, start)}</span>
      <span style={{ color: 'var(--zy-main)', ...style }}>
        {text.slice(start, end)}
      </span>
      <span>{text.slice(end, text.length)}</span>
    </>
  )
}
